import { parsePhoneNumberFromString } from 'libphonenumber-js'

// MobilePay expects the country code and digits only, e.g. 358401234567.
// Numbers typed without a country code are read as Finnish.
export function normalizeMobilepayPhoneNumber (value) {
  if (!value) {
    return null
  }
  const trimmed = String(value).trim().replace(/^00/, '+')
  const parsed = parsePhoneNumberFromString(trimmed, 'FI')
  if (!parsed || !parsed.isPossible()) {
    return null
  }
  return parsed.number.replace(/^\+/, '')
}
